/* src/app/common/components/loader/loader.component.scss */
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  flex-direction: column;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background:
    linear-gradient(
      120deg,
      #FFFFFF 0%,
      #ffe0d1 100%) !important;
  z-index: 999999;
  pointer-events: none;
}
.loader-container.trans {
  background:
    linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.8) 0%,
      #ffe0d1 100%) !important;
}
.loader-container.show {
  pointer-events: all;
}
p {
  color: #000000;
  margin-top: auto;
  margin-bottom: auto;
  font-size: 20px;
  font-weight: 600;
}
.loader-box {
  margin-bottom: auto;
  border: 4px solid #000000;
  border-top: 4px solid #FFFFFF;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=loader.component-RLST67H3.css.map */
